module.exports = {"attributes":{"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"st1\" d=\"M 136.713 13.753 L 101.935 96.879 L 108.16 13.753 L 46.546 13.753 L 1.247 187.463 L 41.393 187.463 L 73.381 73.22 L 63.935 187.463 L 91.629 187.463 L 141.007 73.007 L 113.313 187.463 L 153.459 187.463 L 198.758 13.54 L 136.713 13.753 Z\" style=\"fill: rgb(237, 28, 36);\"></path>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/motorsport.com.svg
// module id = 1332
// module chunks = 0